import { ReactElement } from 'react'
import { ReactDatePickerProps } from 'react-datepicker'
import { TimePickerProps } from 'react-time-picker'
import { FormGroupProps } from 'components'
import { Placement } from 'react-bootstrap/esm/Overlay'

export interface CommonFieldProps extends FormGroupProps {
    name: string
    label?: string|ReactElement
    isRequired?: boolean
    className?: string
    helperText?: string
    placeholder?: string
    listenerWrapperId?: string
}

export interface SwitchFieldProps extends CommonFieldProps {
    checked?: boolean
    isDisabled?: boolean
    size?: 'medium' | 'small'
    onClick?: (e?: any) => void
    placement?: 'top' | 'bottom' | 'right' | 'left'
}
export interface TextFieldProps extends CommonFieldProps {
    type?: string // type="number", type="email", type="color" ...
    showInfoIcon?: boolean
    isDisabled?: boolean
    isReadOnly?: boolean
    prependText?: string
    appendText?: string
    isActiveStatus?: boolean
    status?: string
    statusHelperText?: string
    isTextArea?: boolean
    row?: number // number of row for text area
    textToCopy?: string
    highLightHelperText?: string
    defaultValue?: string
    show?: boolean
}

export interface SelectFieldProps extends CommonFieldProps {
    options: Record<any, any>[]
    isMulti?: boolean
    isClearable?: boolean
    optionValue?: string
    optionLabel?: string
    onSelect?: (data) => void
    isDisabled?: boolean
    defaultValue?: Record<any, any>
    showInfoIcon?: boolean
}

export interface FileUploadProps extends CommonFieldProps {
    accept?: string
    maxSize?: number // in mb
    isMulti?: boolean
    maxFiles?: number
    dependField?: string
    isDisabled?: boolean
    maxImageSize?: {
        width: number
        height: number
    }
    onChange?: (value) => void
    previewImagePlacement?: Placement
    hideLibrary?: boolean
    showLibraryInModal?: boolean
}

export interface MugShotFieldProps extends FileUploadProps {
    isBase64?: boolean
}

export interface FormTab {
    id: string
    name: string
    Component?: React.FC
}
export interface FormTabsProps {
    header?: string
    tabs: FormTab[]
    showHelpContent?: boolean
    helpContentField?: string
    showSpaceOpened?: boolean
    spaceOpenedField?: string
    showInviteOnly?: boolean
    inviteOnlyField?: string
    ignoredChangedKeys?: string[]
}

export interface TimeProps extends CommonFieldProps, Omit<TimePickerProps, 'value'|'name'|'className'> {
    isClearable?: boolean
}

export interface DateProps extends CommonFieldProps, Omit<ReactDatePickerProps,
  'name'|'onChange'|'showTimeSelect'|'timeIntervals'> {
    showInfoIcon?: boolean
}

export interface InviteEmailsProps extends CommonFieldProps {
    initialValue?: Record<string, any>[]
    optionLabel?: string
    optionValue?: string
    onInvite?: (email) => Promise<any>
    onRemove?: (id) => Promise<any>
    callback?: () => void
    modalSize?: 'sm' | 'lg' | 'xl'
    staffsInfo?: Record<string, number>
}

export interface RadioButtonProps extends CommonFieldProps {
    options: Record<string, any>[]
    optionLabel?: string
    optionValue?: string
    isVerticalAlign?: boolean
    defaultValue?: string
}

export enum LocationType {
    VIRTUAL = 'VIRTUAL',
    IN_PERSON = 'IN_PERSON',
    HYBRID = 'HYBRID',
}
